import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Layout from '../../components/Layout/Layout';
import classes from './Celebrities.css';
import BSMLogo from '../../assets/logos/benito-santos-mexico.svg';
import Celebrity from '../../components/Celebrity/Celebrity';
import SectionHeader from '../../components/SectionHeader/SectionHeader';
import * as celebritiesActions from '../../actions/CelebritiesActions';
import * as menuActions from '../../actions/MenuActions';
import { Helmet } from 'react-helmet';

class Celebrities extends Component {
    componentDidMount() {
        this.props.hideAllMenus().then(() => {
            this.props.showTopMenu();
            this.props.showLeftMenu();
        });

        this.props.getCelebrities();
    }

    render() {
        const { celebrities } = this.props;

        const imageOrigin = `${
            process.env.REACT_APP_API_URL
        }/api/containers/files/download/`;

        return (
            <Layout>
                <Helmet>
                    <title>Benito Santos - Celebridades</title>
                </Helmet>
                <section className="container">
                    <header className="row justify-content-center">
                        <div className="col-sm-7 col-xl-4">
                            <SectionHeader
                                logo={BSMLogo}
                                logoAlt="Benito Santos - México"
                                title="Celebridades"
                            />
                        </div>
                    </header>
                    <main>
                        <ul className={'row ' + classes.CelebritiesList}>
                            {celebrities.items.length > 0 ? (
                                celebrities.items.map((celebrity, index) => {
                                    const imageURL =
                                        celebrity.image.length > 0
                                            ? imageOrigin +
                                              celebrity.image[0].name
                                            : '';

                                    return (
                                        <li
                                            className="col-md-6 col-lg-4"
                                            key={index}
                                        >
                                            <Celebrity
                                                name={celebrity.name}
                                                image={imageURL}
                                            />
                                        </li>
                                    );
                                })
                            ) : (
                                <div style={{ margin: 'auto' }}>
                                    Cargando...
                                </div>
                            )}
                        </ul>
                    </main>
                </section>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        celebrities: state.celebrities
    };
};

const mapDispatchToStore = dispatch => {
    return bindActionCreators(
        {
            ...menuActions,
            ...celebritiesActions
        },
        dispatch
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToStore
)(Celebrities);



// WEBPACK FOOTER //
// ./src/containers/Celebrities/Celebrities.js